module.exports = __webpack_public_path__ + "img/person-money.7119eacd.png";